import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { LtbDataService } from './ltb.data.service';
import {UsageType} from './models/usageEventType';
import { UsageEvent } from './models/usageEvent';
import { LateFunding } from './models/lateFundingEvent';
import { LateUtilityFeeAdjustment } from './models/lufaEvent';
import { OpenClose } from './models/OpendCloseEvent';
import { UsageEventBase } from './models/usageEventBase';
import { map, debounce, debounceTime, expand} from 'rxjs/operators';
import { TitleService } from '../shared/services/title.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Subscription, Observable, EMPTY } from 'rxjs';
import { AutoUnsubscribe } from '../shared/decorators/AutoUnsubscribe';
import { SharedDataService } from '../shared/services/shared-data.service';

  // -------- Custom Validation ---------------
  function nonZeroValidator(control: AbstractControl): {[key: string]: boolean} | null {
    if(( Number(control.value) === 0 || isNaN(control.value)) && control.value !== null)
    {
      return {'nonZero': true};
    }
    return null;
  }

  function isNumberValidator(control: AbstractControl): {[key: string]: boolean} | null {
    if(isNaN(control.value) || control.value === null)
    {
      return {'nonNumber': true};
    }
    return null;
  }

@Component({
  selector: 'e2cb-ltb-usage',
  templateUrl: './ltb-usage.component.html',
  styleUrls: ['./ltb-usage.component.scss']
})

@AutoUnsubscribe
export class LtbUsageComponent implements OnInit {
  @ViewChild('template_file_upload', { static: true }) templateFileUpload;

  // #region public
  // model: LtbModel = new LtbModel();
  submitClicked: boolean;
  usageEventTypes = UsageType;
  public files: Set<File> = new Set();
  showSpinner: boolean;
  manualUsageEventForm: FormGroup;
  now: Date;
  currentBillingMonth: Date;
  prevBillingMonth: Date;
  clientUsage: any[] = [];
  ltbProducts: any[] = [];
  // #endregion

  // #region private
  private _billingAgreementSub: Subscription;
  private _manualUsageSub: Subscription;
  // #endregion

  constructor(
    private _titleService: TitleService,
    private _frmbuilder: FormBuilder,
    public sharedDataService: SharedDataService,
    private _ltbDataService: LtbDataService) {

    this._titleService.Subtitle = 'Usage Event Entry';
    this.now = new Date();
    this.currentBillingMonth = new Date(this.now);
    this.prevBillingMonth = new Date(new Date(this.now.setMonth(this.now.getMonth() - 1)));

    // intialize FormGroup
    this.intializeForm();


  }

  async ngOnInit() {
    // populate client list
    this.showSpinner = true;
    try {
      await this.sharedDataService.PopulateAviClientIds()
    } catch(error) {
      this.sharedDataService.HandleError(error);
      this.showSpinner = false;
    } finally {
      this.showSpinner = false;
    }

    // intialize FormGroup
    this.intializeForm();

    // on aviClientId change
    this.manualUsageEventForm.get('aviClientId').valueChanges.subscribe(val =>
    {
       this.manualUsageEventForm.get('usageType').reset(this.usageEventTypes.base);
       this.manualUsageEventForm.get('usageProduct').setErrors(null);
       this.manualUsageEventForm.get('usageProduct').reset('');
       this.manualUsageEventForm.get('amount').setErrors(null);
       this.manualUsageEventForm.get('amount').reset('');
       this.onValidateAviclient(val);
    });

    // onusageProduct change
    this.manualUsageEventForm.get('usageProduct').valueChanges.subscribe(val =>
    {

        // reset usageType formcontrols
      if(this.manualUsageEventForm.dirty)
      {
          this.resetFormGroupsAfterProductValchange();
      }

      if( val.productDescription !== null && val.productDescription !== undefined)
      {
        // if(productDescriptionValue.match('/Product.*?af99./gi')
        if(val.productDescription.toLowerCase().includes('open & close'))
        {
          this.manualUsageEventForm.get('usageType').setValue(this.usageEventTypes.openClose);
        }
        else if( val.productDescription.toLowerCase().includes('late funding'))
        {
          this.manualUsageEventForm.get('usageType').setValue(this.usageEventTypes.lateFunding);
        }
        else if(val.productDescription.toLowerCase().includes('late utility fee adjustment'))
        {
          this.manualUsageEventForm.get('usageType').setValue(this.usageEventTypes.lateUtilityFundingAdjustment);
        }
        else
        {
          this.manualUsageEventForm.get('usageType').setValue(this.usageEventTypes.base);
        }
      }
    });
  }

  manualUsageEventFormToJson(): UsageEventBase{
    if (this.manualUsageEventForm.get('usageType').value === this.usageEventTypes.base) {
      return new UsageEvent(this.manualUsageEventForm);
    }

    if (this.manualUsageEventForm.get('usageType').value === this.usageEventTypes.lateFunding) {
      return new LateFunding(this.manualUsageEventForm);
    }

    if (this.manualUsageEventForm.get('usageType').value === this.usageEventTypes.lateUtilityFundingAdjustment) {
      return new LateUtilityFeeAdjustment(this.manualUsageEventForm);
    }

    if (this.manualUsageEventForm.get('usageType').value === this.usageEventTypes.openClose) {
      return new OpenClose(this.manualUsageEventForm);
    }
  }

  onSubmit(): void {
    if(this._manualUsageSub)
    {
      this._manualUsageSub.unsubscribe();
    }
    this.showSpinner = true;
    this._manualUsageSub = this._ltbDataService.PostLtbUsage(this.manualUsageEventFormToJson()).subscribe(res => {
      if (res.errors.length === 0 )
      {
        alert('SUCCESS!\nDaas LineageID: ' + res.data['deliveryStageDataLineageId']);
      } else
      {
        alert('Error: Usage Event Delivery Failed');
        this.sharedDataService.HandleError(res.errors);
        this.showSpinner = false;
      }
    }, error => {
      this.sharedDataService.HandleError(error);
      this.showSpinner = false;
    }, () => {
      this.showSpinner = false;
      this.manualUsageEventForm.get('aviClientId').setErrors(null);
      this.manualUsageEventForm.get('aviClientId').reset('(required)');
      this.manualUsageEventForm.get('usageType').reset(this.usageEventTypes.base);
      this.manualUsageEventForm.updateValueAndValidity();
    });
  }

  // --------------------------------------------------

  onValidateAviclient(id: string): void {
    if (!this.manualUsageEventForm.get('aviClientId').valid)
    {
      this.manualUsageEventForm.get('usageProduct').disable({onlySelf: true});
    }
    else
    {
      // valid client
      if(id.length === 0)
      {
        return;
      }

      // clear subscription
      if(this._billingAgreementSub)
      {
        this._billingAgreementSub.unsubscribe();
      }
      this.showSpinner = true;

      // clear array if populated
      if(this.clientUsage.length > 0)
      {
        this.clientUsage.length = 0;
      }

      // Data Service Call to get ClientUsageProducts
      this._billingAgreementSub = this._ltbDataService.GetClientUsageProducts(id).pipe(
          expand( res => {

         // check for errors
          if (!res.success)
          {
            this.sharedDataService.HandleError(res.errors);
            this.showSpinner = false;
            return EMPTY;
          }

          // make sure we have data
          if (!res.data || !res.data.results)
          {
            this.showSpinner = false;
            return EMPTY;
          }
          const results = res.data.results;
          results.forEach(result => {

            // Check for existing entries
            var item  = {
                          productDescription: result.productDescription,
                          category: result.category};

            if(this.clientUsage.indexOf(item) === -1)
            {
              this.clientUsage.push({
                productDescription: result.productDescription,
                category: result.category
              });
            }
          });

            // don't recurse if there's no continuation token.
        if (!res.data.continuationToken)
        {
          this.clientUsage = this.clientUsage.sort((a , b) =>  a.productDescription.localeCompare(b.productDescription));
          this.showSpinner = false;
          this.manualUsageEventForm.get('usageProduct').enable({onlySelf: true});
          return EMPTY;
        }

        return this._ltbDataService.GetClientUsageProducts(id, res.data.continuationToken);
        })
      ).subscribe();
    }
  }

  // --------------------------------------------------

  onTemplateDownloadClick(): void {
    this.showSpinner = true;
    this._ltbDataService.GetLtbTemplateFile()
    .pipe(map((res) => {
      return {
        filename: 'manual_usage_template.xlsx',
        data: new Blob(
          [res['body']],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        ),
      };
    }))
    .subscribe(res => {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(res.data, res.filename);
      } else {
        const link = window.URL.createObjectURL(res.data);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = link;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(link);
        a.remove();
      }
    }, error => {
      this.sharedDataService.HandleError(error);
      this.showSpinner = false;
    }, () => {
      this.showSpinner = false;
    });
  }

  // --------------------------------------------------

  onAccrualDownloadClick(): void {
    this.showSpinner = true;
    this._ltbDataService.GetLtbAccrualFile()
    .pipe(map((res) => {
      return {
        filename: 'manual_usage_accrual.xlsx',
        data: new Blob(
          [res['body']],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        ),
      };
    }))
    .subscribe(res => {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(res.data, res.filename);
      } else {
        const link = window.URL.createObjectURL(res.data);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = link;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(link);
        a.remove();
      }
    }, error => {
      this.sharedDataService.HandleError(error);
      this.showSpinner = false;
    }, () => {
      this.showSpinner = false;
    });
  }

  // --------------------------------------------------

  onTemplateUploadClick(): void {
    this.templateFileUpload.nativeElement.click();
  }

  // --------------------------------------------------

  onTemplateFileUploadChanged(): void {
    this.showSpinner = true;
    const files = this.templateFileUpload.nativeElement.files;
    if (files.length === 1) {
      const formData: FormData = new FormData();
      formData.append('file', files[0], files[0].name);

      this._ltbDataService.PostLtbTemplateFile(formData)
        .subscribe(res => {
          if (res.success) {
            alert('File posted successfully.');
          } else {
            this.sharedDataService.HandleError(res.errors);
            this.showSpinner = false;
          }
        }, error => {
          this.sharedDataService.HandleError(error);
          this.showSpinner = false;
        }, () => {
          this.showSpinner = false;
          this.templateFileUpload.nativeElement.value = '';
        });
    }
  }

  // --------------------------------------------------

  private intializeForm(): void {
    this.manualUsageEventForm = this._frmbuilder.group({
      aviClientId: ['', [Validators.required]],
      usageProduct: [{value: '', disabled: true}, [Validators.required]],
      description: '',
      amount: ['', [Validators.required]],
      billingMonth: this.currentBillingMonth,
      accountNumber: '',

      // hidden field for type
      usageType: {value: this.usageEventTypes.base, hidden: true},

      siteGroup: this._frmbuilder.group({
        siteName: '',
        siteCity: '',
        siteState: '',
        siteZipCode: ''
      }),

      ocGroup: this._frmbuilder.group({
        storeNumber: '',
        primaryService: '',
        ocAccountNumber: '',
        address: '',
        utilityName: '',
        meterNumber: '',
        dateRequested: [Date(), []],
        requester: ''
      }),

      lfGroup: this._frmbuilder.group({
        billConsolidationDate: '',
        serviceDescription: '',
        consolidationID: '',
        consolidationInvoiceNumber: '',
        consolidationFundedDate: '',
        daysToBill: [0, [isNumberValidator]]
      })
    });
    this.manualUsageEventForm.controls["amount"].setValue(100);
  }

  // --------------------------------------------------

  private resetFormGroupsAfterProductValchange(): void {
    if( this.manualUsageEventForm.get('siteGroup').dirty)
    {
      this.manualUsageEventForm.get('siteGroup').setErrors(null);
      this.manualUsageEventForm.get('siteGroup').reset('');
    }

    if( this.manualUsageEventForm.get('lfGroup').dirty)
    {
      this.manualUsageEventForm.get('lfGroup').setErrors(null);
      this.manualUsageEventForm.get('lfGroup').reset('');
      this.manualUsageEventForm.get('lfGroup.daysToBill').reset(0);
    }

    if( this.manualUsageEventForm.get('ocGroup').dirty)
    {
      this.manualUsageEventForm.get('ocGroup').setErrors(null);
      this.manualUsageEventForm.get('ocGroup').reset('');
    }

    if( this.manualUsageEventForm.get('accountNumber').dirty)
    {
      this.manualUsageEventForm.get('accountNumber').setErrors(null);
      this.manualUsageEventForm.get('accountNumber').reset('');
    }

    if( this.manualUsageEventForm.get('amount').dirty)
    {
      this.manualUsageEventForm.get('amount').setErrors(null);
      this.manualUsageEventForm.get('amount').reset(null);
    }

    if( this.manualUsageEventForm.get('description').dirty)
    {
      this.manualUsageEventForm.get('description').setErrors(null);
      this.manualUsageEventForm.get('description').reset('');
    }
  }

  // --------------------------------------------------

  onTemplateFileDownloadClick(): void {
    this.showSpinner = true;
    this._ltbDataService.GetLtbTemplateFile()
      .pipe(map((res) => {
        return {
          filename: 'manual_usage_template.xlsx',
          data: new Blob(
            [res['body']],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ),
        };
      }))
      .subscribe(res => {
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
        } else {
          const link = window.URL.createObjectURL(res.data);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = link;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(link);
          a.remove();
        }
      }, error => {
        this.sharedDataService.HandleError(error);
        this.showSpinner = false;
      }, () => {
        this.showSpinner = false;
      });
  }

  // --------------------------------------------------

  onTemplateFileUploadClick() {
    this.templateFileUpload.nativeElement.click();
  }

  // --------------------------------------------------
}
